import React, { createContext, use, useState, useCallback, useMemo, ReactNode } from 'react';

interface ReauthRequiredContextValue {
  reauthRequired: boolean;
  triggerReauthRequired: () => void;
}

// eslint-disable-next-line react-refresh/only-export-components
export const ReauthRequiredContext = createContext<ReauthRequiredContextValue | null>(null);

export const ReauthRequiredProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [reauthRequired, setReauthRequired] = useState(false);
  const triggerReauthRequired = useCallback(() => setReauthRequired(true), []);
  const value = useMemo(() => ({ reauthRequired, triggerReauthRequired }), [reauthRequired, triggerReauthRequired]);

  return (
    <ReauthRequiredContext value={value}>
      {children}
    </ReauthRequiredContext>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useReauthRequired = (): ReauthRequiredContextValue => {
  const ctx = use(ReauthRequiredContext);
  if (!ctx) {
    throw new Error('useReauthRequired must be used within a ReauthRequiredProvider');
  }
  return ctx;
};
